export const fileUpload = {
  csvUploadError: "Error uploading CSV. Please try again",
  confirmRemoveFile: "Are you sure you want to remove this file?",
  uploadSuccess: "Uploaded successfully",
  uploadDescription:
    "Fullscript will scan your file to ensure patient information is formatted correctly. If there are errors, you will have the opportunity to correct them before importing.",
  dragAndDrop: "Drag & drop template here",
  browseComputer: "Browse computer",
  or: "Or",
} as const;
